import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, l = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M10 10.626a4.8 4.8 0 0 1-4.79-4.791 4.8 4.8 0 0 1 4.792-4.792 4.8 4.8 0 0 1 4.791 4.792 4.8 4.8 0 0 1-4.791 4.791m0-8.333A3.55 3.55 0 0 0 6.46 5.835a3.55 3.55 0 0 0 3.542 3.541 3.55 3.55 0 0 0 3.541-3.541 3.55 3.55 0 0 0-3.541-3.542m-7.16 16.665a.63.63 0 0 1-.625-.625c0-3.558 3.491-6.458 7.783-6.458.842 0 1.667.108 2.467.333a.62.62 0 0 1 .433.767.62.62 0 0 1-.767.433A8 8 0 0 0 10 13.125c-3.6 0-6.533 2.333-6.533 5.208a.63.63 0 0 1-.625.625"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M15 18.96a3.92 3.92 0 0 1-2.642-1.025 3.6 3.6 0 0 1-.75-.9A3.9 3.9 0 0 1 11.04 15c0-1.041.4-2.016 1.117-2.758a3.92 3.92 0 0 1 2.841-1.2 3.92 3.92 0 0 1 2.942 1.317A3.95 3.95 0 0 1 18.958 15c0 .317-.042.634-.125.934a3.6 3.6 0 0 1-.459 1.108c-.691 1.183-1.991 1.917-3.375 1.917m0-6.667a2.701 2.701 0 0 0-2.317 4.1c.133.233.308.442.508.617a2.67 2.67 0 0 0 1.808.708c.942 0 1.834-.5 2.317-1.308.142-.234.25-.5.308-.759a2.4 2.4 0 0 0 .084-.641c0-.667-.25-1.309-.7-1.809a2.63 2.63 0 0 0-2.009-.908"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M16.25 15.61h-2.492a.63.63 0 0 1-.625-.626.63.63 0 0 1 .625-.625h2.492a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
}, null, -1), r = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M15 16.882a.63.63 0 0 1-.625-.625v-2.491A.63.63 0 0 1 15 13.14a.63.63 0 0 1 .625.625v2.491c0 .35-.283.625-.625.625"
}, null, -1), s = [
  l,
  a,
  n,
  r
];
function d(i, h) {
  return e(), o("svg", c, [...s]);
}
const u = { render: d };
export {
  u as default,
  d as render
};
